import React from "react";
import { getTitle } from "./constants";
import { Wrapper, Title } from "./styled";
import Detail from "../Table/components/Structure/components/Detail";

const Header = ({ detail }) => {
  return (
    <Wrapper>
      <Title>{getTitle(detail)}</Title>
      <Detail detail={detail} />
    </Wrapper>
  );
};

export default Header;
